import { PaymentProcessorEnum } from '@systemeio/ui'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { PaypalSoapPaymentIntegrationInterface } from '../../paypal-soap/types'
import { PaypalIntegrationTypeInterface, PaypalRestPaymentIntegrationInterface } from '../types'

const showBoth = (id: number | undefined) =>
  id ? [2251, 11479052, 9733734, 4128396, 11045017].includes(id) : false

export const usePaypalIntegrationType = () => {
  const { user, isRootAdmin } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, PaypalIntegrationTypeInterface>({
    method: RequestMethodsEnum.get,
  })

  const { getConnectedPaymentIntegration } = useConnectedPaymentIntegrations()

  const paypalRestIntegration =
    getConnectedPaymentIntegration<PaypalRestPaymentIntegrationInterface>({
      processor: PaymentProcessorEnum.PaypalRest,
    })

  const paypalSoapIntegration =
    getConnectedPaymentIntegration<PaypalSoapPaymentIntegrationInterface>({
      processor: PaymentProcessorEnum.PaypalSoap,
    })

  const hasPaypalIntegration = !!paypalRestIntegration || !!paypalSoapIntegration

  const { data } = useControlledSwr(
    '/secure/paypal/get-integration-type',
    fetcher,
    undefined,
    !hasPaypalIntegration,
  )

  return {
    shouldShowRest:
      !!paypalRestIntegration ||
      data?.integrationType === PaymentProcessorEnum.PaypalRest ||
      showBoth(user?.id) ||
      isRootAdmin,
    shouldShowSoap:
      !!paypalSoapIntegration ||
      data?.integrationType === PaymentProcessorEnum.PaypalSoap ||
      showBoth(user?.id) ||
      isRootAdmin,
  }
}
